<template>
  <div class="page" ref="container" v-cloak>
    <img
      class="top-bg__image"
      src="../../public/img/common/top_bg.png"
      alt=""
    />
    <div class="top-bg__nav">
      <div class="top-bg__back" @click="handlePageBack">
        <div class="top-bg__back-icon"></div>
      </div>
    </div>

    <div class="page-scroll">
      <div class="page-content">
        <!-- 顶部进度卡片 -->
        <div class="form-header-card">
          <div class="form-header-card__clip">
            <img
              class="form-header-card__bg"
              src="../../public/img/register/register_tl12/form_card_bg.png"
              alt=""
            />
            <div class="form-header-card__body">
              <div class="form-header-card__top">
                <div class="form-header-card__amount-wrap">
                  <div class="form-header-card__amount-row">
                    <span class="text-xl font-semibold text-white">¥</span>
                    <span class="text-display-md text-white leading-tight">{{
                      estimatedAmount
                    }}</span>
                  </div>
                  <span class="text-base text-white opacity-85"
                    >预估可借额度(元)</span
                  >
                </div>
                <div
                  v-if="!showProfile"
                  class="form-header-card__step text-xxl text-white"
                >
                  {{ currentStep }}/{{ totalSteps }}
                </div>
                <div
                  v-else
                  class="form-header-card__step invisible text-xxl text-white"
                >
                  0/0
                </div>
              </div>
              <div class="form-header-card__progress">
                <div
                  v-if="!showProfile"
                  class="form-header-card__progress-tooltip"
                  :style="{ left: progress + '%' }"
                >
                  <img
                    class="form-header-card__progress-tooltip-bg"
                    src="../../public/img/register/register_tl12/step_bg.png"
                    alt=""
                  />
                  <span class="form-header-card__progress-tooltip-text"
                    >{{ progress }}%</span
                  >
                </div>
                <div class="form-header-card__progress-track">
                  <div
                    class="form-header-card__progress-fill"
                    :style="{ width: (showProfile ? 100 : progress) + '%' }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showProfile" class="form-header-card__complete">
            <img
              class="form-header-card__complete-bg"
              src="../../public/img/register/register_tl12/form_step_bg.png"
              alt=""
            />
            <div class="form-header-card__complete-text">
              <span class="text-xs text-white leading-relaxed">完成进度</span>
              <span class="text-base text-white font-bold leading-tight"
                >100%</span
              >
            </div>
          </div>
        </div>

        <!-- 七步选项 -->
        <div
          v-if="!showProfile"
          class="form-card bg-surface rounded-lg shadow-card"
        >
          <span
            class="form-card__title text-lg text-primary font-medium text-center"
            >{{ currentTitle }}</span
          >
          <div class="form-card__options">
            <div
              v-for="item in currentOptions"
              :key="item.dictLabel"
              class="form-option text-center"
              :class="item.selected ? 'form-option--selected' : 'bg-page'"
              @click="onSelectOption(item)"
            >
              <span
                class="text-base"
                :class="
                  item.selected ? 'text-brand font-medium' : 'text-secondary'
                "
                >{{ item.dictLabel }}</span
              >
            </div>
          </div>
        </div>

        <!-- 资料填写 -->
        <template v-else>
          <div class="profile-card bg-surface rounded-lg shadow-card">
            <div class="profile-safe">
              <img
                class="profile-safe__icon"
                src="../../public/img/register/register_tl12/safe_icon.png"
                alt=""
              />
              <div class="profile-safe__content">
                <span class="text-base text-primary font-medium"
                  >官方认证，保护您的隐私安全</span
                >
                <span class="text-sm text-hint"
                  >您的信息仅用于真实性验证，平台保护您的隐私安全</span
                >
              </div>
            </div>

            <div class="profile-row">
              <span class="profile-row__label text-base text-primary"
                >姓名</span
              >
              <input
                class="profile-row__input text-base text-primary"
                placeholder="请输入您的真实姓名"
                :maxlength="realNameMaxLength"
                v-model.trim="name"
                @input="onNameInput"
              />
            </div>

            <div class="profile-row">
              <span class="profile-row__label text-base text-primary"
                >身份证号</span
              >
              <input
                class="profile-row__input text-base text-primary"
                placeholder="请输入您的身份证号"
                maxlength="18"
                v-model.trim="idCard"
                @input="onIdCardInput"
              />
            </div>

            <div class="profile-row" @click="handleClickPosition">
              <span class="profile-row__label text-base text-primary"
                >当前居住城市</span
              >
              <div class="profile-row__value-wrap">
                <span
                  class="text-base"
                  :class="
                    cityDisplay ? 'text-primary' : 'profile-row__placeholder'
                  "
                  >{{ cityDisplay || "请选择" }}</span
                >
                <div class="icon-arrow-right"></div>
              </div>
            </div>
          </div>

          <div class="submit-section">
            <div class="submit-msg">
              <img
                class="submit-msg__bg"
                src="../../public/img/register/register_tl12/msg_bg.png"
                alt=""
              />
              <span class="submit-msg__text text-sm text-white"
                >新用户申请成功率高达90%</span
              >
            </div>
            <div
              class="submit-btn bg-primary text-lg text-white font-medium text-center"
              :class="{ 'submit-btn--disabled': submitting }"
              @click="onSubmitProfile"
            >
              {{ submitting ? "提交中..." : "提交申请" }}
            </div>
            <div class="agreement-row" @click="onToggleAgreement">
              <img
                v-if="agreed"
                class="agreement-checkbox"
                src="../../public/img/register/register_tl12/check_circle_icon.png"
                alt=""
              />
              <img
                v-else
                class="agreement-checkbox"
                src="../../public/img/register/register_tl12/circle_icon.png"
                alt=""
              />
              <span class="agreement-text text-sm text-hint"
                >我已阅读并同意签署<span
                  class="text-brand"
                  @click.stop="onShowProtocol('xxsq')"
                  >《个人信息共享授权书》</span
                ><span class="text-brand" @click.stop="onShowProtocol('mzsm')"
                  >《免责声明》</span
                ></span
              >
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 城市选择 -->
    <van-popup
      v-model="showPickerCity"
      position="bottom"
      safe-area-inset-bottom
      round
    >
      <van-picker
        show-toolbar
        :columns="areaList"
        @change="onCityChange"
        @confirm="onAreaConfirm"
        @cancel="showPickerCity = false"
        value-key="localName"
      >
        <div slot="title" class="picker-title u-text-center">
          <p>请选择定位城市</p>
          <p class="pa">
            准确的贷款申请城市将决定我们是否能为您提供贷款服务，请按您所在地如实填写
          </p>
        </div>
      </van-picker>
    </van-popup>

    <!-- 协议弹窗 -->
    <div class="protocol-modal" v-if="showProtocolModal" @touchmove.prevent>
      <div class="protocol-modal__mask" @click="onCloseProtocolModal"></div>
      <div class="protocol-modal__sheet" @touchmove.stop>
        <div class="protocol-modal__header">
          <span class="protocol-modal__title">{{ protocolTitle }}</span>
          <span class="protocol-modal__close" @click="onCloseProtocolModal"
            >×</span
          >
        </div>
        <div class="protocol-modal__body">
          <div
            class="protocol-modal__content protocol-content"
            v-html="protocolContent"
          ></div>
        </div>
      </div>
    </div>

    <!-- 离开确认弹窗 -->
    <leave-confirm-modal
      :visible.sync="leaveModalVisible"
      @leave="onLeaveModalLeave"
      @stay="onLeaveModalStay"
    />

    <Agreement
      @handleGoOn="handleGoOn"
      :incomingShow="incomingShow"
      :sendData="sendData"
      :form="form"
      :applyTime="applyTime"
      :companys="companys"
      :companyAlias="companyAlias"
      :productId="productId"
      :applyId="applyId"
    />

    <MatchLoading :visible="matchVisible" @finish="onMatchAnimFinish" />
  </div>
</template>

<script>
import * as API_Common from "@/api/common.js";
import Agreement from "../components/Agreement";
import MatchLoading from "../components/MatchLoading";
import LeaveConfirmModal from "../components/LeaveConfirmModal";
import { applyCommon } from "@/mixins/applyCommon.js";
import { mapPosition } from "@/mixins/mapPosition.js";
import { applyBus } from "@/mixins/applyBusEntry.js";
import { setEncryption } from "@/utils/encrypt";
import {
  FORM_STEPS,
  TOTAL_FORM_STEPS,
  buildAssetsArray,
} from "@/constants/formOptions.js";

const REAL_NAME_REGEX = /^[\u4e00-\u9fa5·]{2,10}$/;
const REAL_NAME_MAX_LENGTH = 10;

const PROTOCOL_TITLES = {
  xxsq: "个人信息共享授权书",
  mzsm: "免责声明",
};

export default {
  name: "RegisterEntryTl12",
  components: { Agreement, MatchLoading, LeaveConfirmModal },
  mixins: [applyCommon, mapPosition, applyBus],
  data() {
    return {
      estimatedAmount: "50,000",
      showProfile: false,
      currentStep: 1,
      totalSteps: TOTAL_FORM_STEPS,
      progress: 0,
      currentTitle: FORM_STEPS[0].title,
      currentOptions: [],
      answers: {},
      name: "",
      idCard: "",
      positionStatus: false,
      positionCityStatus: false,
      provinceArr: undefined,
      isSelectAddr: false,
      loading: false,
      stepLineMarginL: -92,
      submitting: false,
      leaveModalVisible: false,
      historyTrapDepth: 0, // pushState 拦截层数，离开时需一并回退
      realNameMaxLength: REAL_NAME_MAX_LENGTH,
      showPickerCity: false,
      areaList: [{ values: [] }, { values: [] }],
      address: { province: "", city: "" },
      agreed: false,
      showProtocolModal: false,
      protocolTitle: "",
      protocolContent: "",
      xxsq: "",
      mzsm: "",
      incomingShow: false,
      sendData: null,
      applyId: "",
      productId: null,
      hasPushSuccess: undefined,
      applyTime: "",
      redirectUrl: "",
      companys: "",
      companyAlias: "",
      form: {
        channelNo: this.$route.query.source,
        loanAmount: this.$route.query.amount ? this.$route.query.amount : 0,
        loanPeriod:
          parseInt(this.$route.query.period) === 9
            ? 12
            : parseInt(this.$route.query.period) || 12,
        loanPurpose: this.$route.query.purpose,
        reqId: this.$route.query.reqId,
        gpsCityName: "",
        cityId: "",
        provinceId: "",
      },
      brand: this.$route.query.brand,
      downPageUrl: this.$route.query.downPageUrl,
      isRedirectProductsPage: parseInt(
        this.$route.query.isRedirectProductsPage
      ),
      isRedirectWorkWeixinPage: parseInt(
        this.$route.query.isRedirectWorkWeixinPage
      ),
      env: process.env.NODE_ENV,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.handleLoadFinish(9);
    });

    if (this.form.loanAmount) {
      const amount =
        Number(String(this.form.loanAmount).replace(/,/g, "")) || 0;
      this.estimatedAmount = amount.toLocaleString("en-US");
    }

    this.updateStepView(1);
    this.addHistory();
    this.checkPosition();
    this.loadProtocolContent();

    this.$nextTick(() => {
      this.handleLoadFinish(12);
    });
  },
  destroyed() {
    this.unlockPageScroll();
    this.unbindBack();
  },
  methods: {
    updateStepView(step) {
      const stepData = FORM_STEPS[step - 1];
      const progress = Math.round(((step - 1) / TOTAL_FORM_STEPS) * 100);
      const selectedLabel = (this.answers[stepData.key] || {}).dictLabel || "";

      this.currentStep = step;
      this.progress = progress;
      this.currentTitle = stepData.title;
      this.currentOptions = stepData.options.map((option) => ({
        dictValue: option.dictValue,
        dictLabel: option.dictLabel,
        selected: option.dictLabel === selectedLabel,
      }));
    },

    onSelectOption(item) {
      const stepData = FORM_STEPS[this.currentStep - 1];
      const answer = {
        dictValue: item.dictValue,
        dictLabel: item.dictLabel,
      };

      this.$set(this.answers, stepData.key, answer);

      if (this.currentStep >= TOTAL_FORM_STEPS) {
        this.showProfile = true;
        return;
      }

      this.updateStepView(this.currentStep + 1);
    },

    onNameInput() {
      this.name = this.name
        .replace(/[^\u4e00-\u9fa5·]/g, "")
        .slice(0, REAL_NAME_MAX_LENGTH);
    },

    onIdCardInput() {
      this.idCard = this.idCard.replace(/[^\dXx]/g, "").slice(0, 18);
    },

    isRealName(value) {
      return REAL_NAME_REGEX.test((value || "").trim());
    },

    validateProfile() {
      if (!this.name.trim()) {
        this.$toast("请输入姓名");
        return null;
      }
      if (!this.isRealName(this.name)) {
        this.$toast("请输入正确的姓名");
        return null;
      }
      if (!this.idCard.trim()) {
        this.$toast("请输入身份证号码");
        return null;
      }
      if (!this.regTest.regIdcard.test(this.idCard.trim())) {
        this.$toast("请输入正确的身份证号码");
        return null;
      }
      if (!this.answers.credit?.dictValue) {
        this.$toast("请选择芝麻分");
        return null;
      }
      if (buildAssetsArray(this.answers).length === 0) {
        this.$toast("请至少选择一项资产");
        return null;
      }
      if (!this.answers.profession?.dictLabel) {
        this.$toast("请选择职业");
        return null;
      }
      if (
        this.answers.overdue?.dictValue === undefined ||
        this.answers.overdue?.dictValue === ""
      ) {
        this.$toast("请选择逾期情况");
        return null;
      }
      if (!this.positionStatus && this.form.cityId === "") {
        this.$toast("请选择您所在的城市");
        return null;
      }
      return true;
    },

    buildApplyPayload() {
      return {
        channelNo: this.form.channelNo,
        loanAmount: Number(String(this.form.loanAmount).replace(/,/g, "")) || 0,
        loanPeriod: this.form.loanPeriod,
        loanPurpose: this.form.loanPurpose || "",
        realName: setEncryption(this.name.trim()),
        idCard: setEncryption(this.idCard.trim()),
        credit: String(this.answers.credit?.dictValue || ""),
        profession: this.answers.profession?.dictLabel || "",
        overdue: this.answers.overdue?.dictValue ?? 0,
        assets: buildAssetsArray(this.answers),
        gpsCityName: this.form.gpsCityName,
        cityId: this.form.cityId,
        provinceId: this.form.provinceId,
        reqId: this.form.reqId || "",
      };
    },

    loadProtocolContent() {
      Promise.all([API_Common.getContent(13), API_Common.getContent(14)])
        .then((res) => {
          if (res[0]?.data?.content) {
            this.xxsq = res[0].data.content;
          }
          if (res[1]?.data?.content) {
            this.mzsm = res[1].data.content;
          }
        })
        .catch(() => {});
    },

    onToggleAgreement() {
      this.agreed = !this.agreed;
    },

    onShowProtocol(type) {
      const content = this[type];
      if (!content) {
        this.$toast("协议加载中，请稍后再试");
        return;
      }
      this.protocolTitle = PROTOCOL_TITLES[type] || "";
      this.protocolContent = content;
      this.showProtocolModal = true;
      this.lockPageScroll();
    },

    onCloseProtocolModal() {
      this.showProtocolModal = false;
      this.protocolTitle = "";
      this.protocolContent = "";
      this.unlockPageScroll();
    },

    lockPageScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this._protocolScrollTop = scrollTop;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollTop}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
    },

    unlockPageScroll() {
      if (document.body.style.position !== "fixed") return;
      const scrollTop = this._protocolScrollTop || 0;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      window.scrollTo(0, scrollTop);
      this._protocolScrollTop = 0;
    },

    onSubmitProfile() {
      if (this.submitting || this.matchRunning) return;
      if (!this.validateProfile()) return;
      if (!this.agreed) {
        this.$toast("请勾选同意授权及告知书");
        return;
      }

      this.submitting = true;
      this.submitAnEntryWithMatchLoading(this.buildApplyPayload());
    },

    handlePageBack() {
      if (this.matchVisible) {
        return;
      }
      if (this.leaveModalVisible) {
        this.leaveModalVisible = false;
        return;
      }
      if (this.showProtocolModal) {
        this.onCloseProtocolModal();
        return;
      }
      if (this.showPickerCity) {
        this.showPickerCity = false;
        return;
      }
      if (this.showProfile) {
        this.showProfile = false;
        this.updateStepView(TOTAL_FORM_STEPS);
        return;
      }
      if (this.currentStep > 1) {
        this.updateStepView(this.currentStep - 1);
        return;
      }
      this.leaveModalVisible = true;
    },

    onLeaveModalStay() {
      this.leaveModalVisible = false;
    },

    onLeaveModalLeave() {
      this.leaveModalVisible = false;
      this.unbindBack();
      // 拦截层 + 当前路由页，一并回退才能真正离开
      window.history.go(-(this.historyTrapDepth + 1));
    },

    addHistory() {
      window.history.pushState(null, null, document.URL);
      this.historyTrapDepth = 1;
      window.addEventListener("popstate", this.onPopState, false);
    },

    unbindBack() {
      window.removeEventListener("popstate", this.onPopState, false);
    },

    onPopState() {
      this.handlePageBack();
      window.history.pushState(null, null, document.URL);
      this.historyTrapDepth += 1;
    },
  },
  computed: {
    /**
     * 居住城市展示文案（city || '请选择'）
     * 仅在真正有省市/手动选择结果时返回内容，否则空串走 placeholder
     */
    cityDisplay() {
      if (this.form.gpsCityName) {
        return this.form.gpsCityName;
      }
      if (this.positionStatus) {
        const name = `${this.address.province || ""} ${
          this.address.city || ""
        }`.trim();
        if (name) {
          return name;
        }
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped src="@/assets/styles/registerEntry_tl12.scss"></style>
